import { render, staticRenderFns } from "./ProductDetailMobileLoader.vue?vue&type=template&id=7e5010fe&scoped=true&"
import script from "./ProductDetailMobileLoader.vue?vue&type=script&lang=js&"
export * from "./ProductDetailMobileLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailMobileLoader.vue?vue&type=style&index=0&id=7e5010fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5010fe",
  null
  
)

export default component.exports